document.addEventListener("DOMContentLoaded", () => {
  
  let headerBenefitSlidingIndex = 0;

  if(window.innerWidth < 950) {
  autoSlideHeaderBenefits();
  }

  function autoSlideHeaderBenefits() {
    let i;
    const x = document.getElementsByClassName("header-benefits-bar__item");
    for (i = 0; i < x.length; i++) {
      x[i].classList.remove("header-benefits-bar__item--active");
    }
    headerBenefitSlidingIndex++;
    if (headerBenefitSlidingIndex > x.length) {headerBenefitSlidingIndex = 1}    
    x[headerBenefitSlidingIndex-1].classList.add("header-benefits-bar__item--active");
    setTimeout(autoSlideHeaderBenefits, 2500); // Change image every 2 seconds
  }
  }); 